import e from "gatsby-background-image";
import r from "react";
function l() {
  return (l = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var l = arguments[r];
      for (var t in l) Object.prototype.hasOwnProperty.call(l, t) && (e[t] = l[t]);
    }
    return e;
  }).apply(this, arguments);
}
const t = e => "[object String]" === Object.prototype.toString.call(e),
  n = e => "fixed" === e.layout ? "fixed" : "fluid",
  i = e => {
    let r;
    for (r = 0; r < e.length; r++) if (!t(e[r])) return e[r];
    return null;
  },
  u = e => e.width / e.height,
  a = e => {
    var r, l, t, n;
    return e.placeholder ? null != (r = e.placeholder) && null != (l = r.fallback) && l.includes("base64") ? {
      base64: null == (t = e.placeholder) ? void 0 : t.fallback
    } : {
      tracedSVG: null == (n = e.placeholder) ? void 0 : n.fallback
    } : {};
  },
  c = e => {
    if (e.srcSet) {
      var r;
      const l = [...e.srcSet.matchAll(/(?:([^"'\s,]+)\s*(?:\s+\d+[wx])(?:,\s*)?)/gm)],
        t = e.sizes.replace("px", ""),
        n = l.filter(e => (null == e ? void 0 : e[0].includes("100w")) || (null == e ? void 0 : e[0].includes("1x")) || (null == e ? void 0 : e[0].includes(`${t}w`)));
      return (null == n || null == (r = n[0]) ? void 0 : r[1]) || "";
    }
    return "";
  },
  s = e => {
    var r, l, t;
    return null != (r = e.images) && r.sources && Array.isArray(null == (l = e.images) ? void 0 : l.sources) ? null == (t = e.images) ? void 0 : t.sources.reduce((e, r) => {
      var l;
      const t = (null == r || null == (l = r.type) ? void 0 : l.split("/")[1]) || "",
        n = (null == t ? void 0 : t.charAt(0).toUpperCase()) + t.slice(1),
        i = `srcSet${n}`,
        u = `src${n}`;
      return n && (!(i in e) && null != r && r.srcSet && (e[i] = r.srcSet), !(u in e) && null != r && r.srcSet && (e[u] = c(r))), e;
    }, {}) : {};
  },
  o = e => {
    if (e && e.layout) {
      const r = {},
        t = n(e),
        i = u(e),
        c = a(e),
        o = s(e);
      return r[t] = l({}, e.images.fallback, o, c, "fluid" === t ? {
        aspectRatio: i
      } : {}, "fixed" === t ? {
        width: e.width,
        height: e.height
      } : {}), r;
    }
    return null;
  };
function d(e) {
  if (e) {
    if (Array.isArray(e)) {
      const [r, u] = (e => {
        const r = i(e);
        if (r) {
          const i = n(r),
            u = e.map(e => {
              if (t(e)) return e;
              const r = o(e);
              return l({}, r && r[i], null != e && e.media ? {
                media: e.media
              } : {});
            });
          return [i, u];
        }
        return [];
      })(e);
      return r ? {
        [r]: u
      } : null;
    }
    return o(e);
  }
  return null;
}
const f = l => {
  const {
      image: t,
      children: n
    } = l,
    i = function (e, r) {
      if (null == e) return {};
      var l,
        t,
        n = {},
        i = Object.keys(e);
      for (t = 0; t < i.length; t++) r.indexOf(l = i[t]) >= 0 || (n[l] = e[l]);
      return n;
    }(l, ["image", "children"]),
    u = t && d(t);
  return u ? r.createElement(e, Object.assign({}, u, i), n) : r.createElement("div", null, n);
};
export { f as BgImage, o as convertSingleBgImage, d as convertToBgImage, s as getAllExtraSrcSets, u as getAspectRatio, n as getBgImageType, a as getPlaceholder, i as getSingleImage, c as getSrc, t as isString };